import { useCallback, useMemo } from 'react';
import { useLocalStorage } from '@frontend/web-storage';
import { LocationServiceLocationItem, LocationServiceRecentLocation } from '../types/location.types';

export const PINNED_LOCATIONS_KEY = 'wam-location-service__pinned-locations';

export const usePinnedLocations = () => {
  const [value, setState] = useLocalStorage<LocationServiceRecentLocation[]>({
    key: PINNED_LOCATIONS_KEY,
    defaultValue: [],
  });

  const locations = useMemo(() => {
    return value || [];
  }, [value]);

  const removeLocation = useCallback(
    (locationId: string) => {
      const updatedLocations = locations.filter((location) => location.locationId !== locationId);

      setState(updatedLocations);
    },
    [locations]
  );

  const addLocation = useCallback(
    ({ locationId, name = locationId }: LocationServiceLocationItem) => {
      if (isPinnedLocation(locationId)) {
        return;
      }

      const updatedLocations = [
        { locationId, name, created: Date.now() },
        ...locations.filter((l) => l.locationId !== locationId),
      ];

      setState(updatedLocations);
    },
    [locations]
  );

  const isPinnedLocation = useCallback(
    (locationId: string) => {
      return locations.some((location) => location.locationId === locationId);
    },
    [locations]
  );

  return { locations, addLocation, removeLocation, isPinnedLocation };
};
